import { render, staticRenderFns } from "./article_edit.vue?vue&type=template&id=5d03336b&scoped=true&"
import script from "./article_edit.vue?vue&type=script&lang=js&"
export * from "./article_edit.vue?vue&type=script&lang=js&"
import style0 from "./article_edit.vue?vue&type=style&index=0&id=5d03336b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d03336b",
  null
  
)

export default component.exports